import React, { PropsWithChildren } from 'react'
import { getClassNames } from '../../../_utils/classnames'
import { Flex } from 'antd'

interface INotificationBuilderMain {
    className?: string
}

const NotificationBuilderMain: React.FunctionComponent<PropsWithChildren<INotificationBuilderMain>> = (props) => {
    const { className, children } = props

    return (
        <Flex
            vertical
            justify="flex-start"
            flex={'1 0 0'}
            gap={16}
            className={getClassNames('notification-builder-main', className)}
        >
            {children}
        </Flex>
    )
}

export default NotificationBuilderMain
